/**
 * Render a curated subset of the element's computed styles into a
 * compact multi-line string suitable for stashing in
 * `AfsAnnotation.computedStyles`. The forensic output level dumps every
 * cascaded property.
 */
const CURATED_PROPS = [
    "display",
    "position",
    "visibility",
    "opacity",
    "z-index",
    "overflow",
    "width",
    "height",
    "min-width",
    "min-height",
    "max-width",
    "max-height",
    "margin",
    "padding",
    "border-radius",
    "box-shadow",
    "color",
    "background-color",
    "background-image",
    "font-family",
    "font-size",
    "font-weight",
    "line-height",
    "text-align",
    "text-transform",
    "flex-direction",
    "justify-content",
    "align-items",
    "gap",
    "grid-template-columns",
    "transform",
    "transition",
    "animation",
];
const collectCurated = (style) => {
    const lines = [];
    for (const prop of CURATED_PROPS) {
        const v = style.getPropertyValue(prop);
        if (!v)
            continue;
        if (v === "none" || v === "normal" || v === "auto" || v === "0px")
            continue;
        lines.push(`${prop}: ${v};`);
    }
    return lines.join("\n");
};
const collectAll = (style) => {
    const lines = [];
    for (let i = 0; i < style.length; i += 1) {
        const prop = style.item(i);
        if (!prop)
            continue;
        const value = style.getPropertyValue(prop);
        if (!value)
            continue;
        lines.push(`${prop}: ${value};`);
    }
    return lines.join("\n");
};
export const getComputedStylesString = (el, detail = "standard") => {
    const view = el.ownerDocument?.defaultView ?? window;
    const style = view.getComputedStyle(el);
    if (detail === "forensic")
        return collectAll(style);
    return collectCurated(style);
};
//# sourceMappingURL=computedStyles.js.map